import { Box, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { useState, useEffect } from 'react';
import { IJobsDownloadTemplate, getJobsDownloadTemplates } from 'wisestep-api';

interface JobsDownloadProps {
  selectedFields: (v: IJobsDownloadTemplate) => void;
}
const JobsDownloadTemplates = ({ selectedFields }: JobsDownloadProps) => {
  const [templatesData, setTempaletes] = useState<IJobsDownloadTemplate[]>([]);
  const [value, setValue] = useState('Select Template');
  useEffect(() => {
    const fetchDataDownloadSettings = async () => {
      const getDataDownloadSettingsRes = await getJobsDownloadTemplates();
      setTempaletes(getDataDownloadSettingsRes.data);
    };
    fetchDataDownloadSettings();
  }, []);
  const handleChange = (event: SelectChangeEvent) => {
    setValue(event.target.value);
    const obj = templatesData?.find((e) => e.name === event.target.value);
    selectedFields(obj ?? ({} as IJobsDownloadTemplate));
  };
  return (
    <Box flexDirection="row">
      <Select
        value={value}
        onChange={handleChange}
        size="small"
        sx={{ maxWidth: 100 }}
        placeholder="Selct template"
        inputProps={{ 'aria-label': 'Without label' }}
      >
        <MenuItem value="" disabled selected>
          Select your Template
        </MenuItem>

        {templatesData?.map(
          (m) =>
            !m.isHidden && (
              <MenuItem key={m.id} value={m.name}>
                {m.name}
              </MenuItem>
            )
        )}
      </Select>
    </Box>
  );
};
export default JobsDownloadTemplates;
